<template>
    <div class="code-container" @click="freshCode">
        <canvas id="code-canvas" :width="contentWidth" :height="contentHeight"></canvas>
    </div>
</template>
<script>
    export default {
        props: {
            //验证码范围code
            identifyCode: {
                type: String,
                default: '1234'
            },
            //验证码字符最小
            fontSizeMin: {
                type: Number,
                default: 16
            },
            //验证码字符最大
            fontSizeMax: {
                type: Number,
                default: 40
            },
            //背景颜色最小数值
            backgroundColorMin: {
                type: Number,
                default: 180
            },
            //背景颜色最大数值
            backgroundColorMax: {
                type: Number,
                default: 240
            },
            //字体颜色最小数值
            colorMin: {
                type: Number,
                default: 50
            },
            //字体颜色最大数值
            colorMax: {
                type: Number,
                default: 160
            },
            //干扰线颜色最小数值
            lineColorMin: {
                type: Number,
                default: 40
            },
            //干扰线颜色最大数值
            lineColorMax: {
                type: Number,
                default: 180
            },
            //干扰点颜色最小数值
            dotColorMin: {
                type: Number,
                default: 0
            },
            //干扰点颜色最大数值
            dotColorMax: {
                type: Number,
                default: 255
            },
            //验证码内容宽度
            contentWidth: {
                type: Number,
                default: 112
            },
            //验证码内容高度
            contentHeight: {
                type: Number,
                default: 38
            }
        },

        methods: {
            // 生成一个随机数
            randomNum(min, max) {
                return Math.floor(Math.random() * (max - min) + min)
            },
            // 生成一个随机的颜色
            randomColor(min, max) {
                let r = this.randomNum(min, max)
                let g = this.randomNum(min, max)
                let b = this.randomNum(min, max)
                return 'rgb(' + r + ',' + g + ',' + b + ')'
            },
            //生成图片
            drawPic() {
                let canvas = document.getElementById('code-canvas')
                let ctx = canvas.getContext('2d')
                ctx.textBaseline = 'bottom'
                // 绘制背景
                // ctx.fillStyle = this.randomColor(this.backgroundColorMin, this.backgroundColorMax)
                ctx.fillStyle = 'rgb(255,247,230)'
                ctx.fillRect(0, 0, this.contentWidth, this.contentHeight)
                // 绘制文字
                for (let i = 0; i < this.identifyCode.length; i++) {
                    this.drawText(ctx, this.identifyCode[i], i)
                }
                this.drawLine(ctx)
                this.drawDot(ctx)
            },
            //生成数字
            drawText(ctx, txt, i) {
                ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax)
                ctx.font = this.randomNum(this.fontSizeMin, this.fontSizeMax) + 'px SimHei'
                let x = (i + 1) * (this.contentWidth / (this.identifyCode.length + 1))
                let y = this.randomNum(this.fontSizeMax, this.contentHeight - 5)
                var deg = this.randomNum(-45, 45)
                // 修改坐标原点和旋转角度
                ctx.translate(x, y)
                ctx.rotate(deg * Math.PI / 180)
                ctx.fillText(txt, 0, 0)
                // 恢复坐标原点和旋转角度
                ctx.rotate(-deg * Math.PI / 180)
                ctx.translate(-x, -y)
            },
            // 绘制干扰线
            drawLine(ctx) {
                // 绘制干扰线
                for (let i = 0; i < 6; i++) {
                    ctx.strokeStyle = this.randomColor(this.lineColorMin, this.lineColorMax)
                    ctx.beginPath()
                    ctx.moveTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight))
                    ctx.lineTo(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight))
                    ctx.stroke()
                }
            },
            // 绘制干扰点
            drawDot(ctx) {
                // 绘制干扰点
                for (let i = 0; i < 20; i++) {
                    ctx.fillStyle = this.randomColor(0, 255)
                    ctx.beginPath()
                    ctx.arc(this.randomNum(0, this.contentWidth), this.randomNum(0, this.contentHeight), 1, 0, 2 * Math.PI)
                    ctx.fill()
                }
            },
            //点击更新时间
            freshCode() {
                this.$emit('freshCode')
            }
        },
        watch: {
            identifyCode() {
                this.drawPic()
            }
        },
        mounted() {
            this.drawPic()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/PictureVerification.vue